import React, {ReactNode, useMemo} from 'react';
import {FC} from 'react';
import {cn} from '@/utils';
import {useScreenSize} from '../hooks/size.hooks';
import './recharge-tip.css';

function getTipCharCount(node: ReactNode): number {
  if (node == null || typeof node === 'boolean') {
    return 0;
  }
  if (typeof node === 'string' || typeof node === 'number') {
    return String(node).length;
  }
  if (Array.isArray(node)) {
    return node.reduce((n, child) => n + getTipCharCount(child), 0);
  }
  if (typeof node === 'object' && node !== null && 'props' in node) {
    const props = (node as {props?: {children?: ReactNode}}).props;
    if (props?.children != null) {
      return getTipCharCount(props.children);
    }
  }
  return 0;
}

interface RechargeTipProps {
  payMethodBonus?: number;
  payMethodScale?: number;
  payCurrentScale?: number;
  children?: ReactNode;
  style?: React.CSSProperties;
  animateType?: '90' | '95';
}

const RechargeTip: FC<RechargeTipProps> = ({
  payCurrentScale: payCurrentScale,
  payMethodBonus,
  payMethodScale: payMethodScale,
  children,
  style = {},
  animateType = '90',
}) => {
  const {calcActualSize} = useScreenSize();
  const payStr = useMemo(() => {
    const payMethodStr =
      payMethodScale || payMethodBonus
        ? payMethodScale
          ? `${payMethodScale * 100}%`
          : payMethodBonus
        : '';
    const payCurrentStr = payCurrentScale ? `${payCurrentScale * 100}%` : '';
    if (payMethodStr && payCurrentStr) {
      return `${payMethodStr}+${payCurrentStr}`;
    }
    if (payMethodStr) {
      return `+${payMethodStr}`;
    }
    if (payCurrentStr) {
      return `+${payCurrentStr}`;
    }
    return '';
  }, [payCurrentScale, payMethodBonus, payMethodScale]);
  const charCount = useMemo(() => {
    const display = children ? children : payStr;
    return getTipCharCount(display);
  }, [children, payStr]);
  // 如果children不为空，则展示children
  if (!children) {
    return null;
  }
  return payStr || children ? (
    <div
      style={{
        ...style,
      }}
      className={`recharge-tip-${animateType} flex flex-row absolute left-1/2 max-w-full whitespace-nowrap
       bg-[#DC0000] py-0.5 px-1.5 rounded-r-xl rounded-tl-lg z-[1] ${
         charCount >= 12 ? '-top-1.5' : '-top-2'
       }`}>
      <span
        className={cn(
          'text-[#FFF29C] font-bold',
          charCount >= 12 ? 'text-[0.5rem]' : 'text-[0.625rem]',
        )}>
        {children ? children : payStr}
      </span>
      <div
        style={{
          position: 'absolute',
          top: '100%',
          left: 0,
          width: 0,
          height: 0,
          borderTop: `${calcActualSize(4)}px solid #DC0000`,
          borderRight: `${calcActualSize(4)}px solid transparent`,
        }}
      />
    </div>
  ) : (
    <></>
  );
};

export default RechargeTip;
